<template>
  <div class="locale-changer">
    <button v-for="option in options" v-bind:data-lang="option.code" :key="`Lang${option.code}`" v-on:click="toggleLang" class="locale-flag"><img :src="getFlag(option.code)" :alt=option.name /></button>
  </div>
</template>

<script>
export default {
  name: 'locale-changer',
  data () {
    return {
      langs: [ { name: 'Português', code: 'pt' }, { name: 'Castellano', code: 'es' }],
      options: [ { name: 'Português', code: 'pt' }, { name: 'Castellano', code: 'es' }]
    }
  },
  mounted: function() {
    const language = document.querySelector(`button[data-lang="${this.$i18n.locale}"]`)
    if (language) language.setAttribute('aria-pressed', 'true')
  },
  methods: {
    getFlag(code) {
      return require('../assets/images/flags/' + code + '.svg')
    },
    toggleLang(event) {
      const target = event.currentTarget

      // first we remove any lang toggle that is pressed
      document.querySelectorAll('button[data-lang]').forEach((button) => {
        button.setAttribute('aria-pressed', 'false')
      })

      target.setAttribute('aria-pressed', 'true')
      this.$i18n.locale = target.dataset.lang
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/variables';

  .locale-changer {
    margin-top: 0.9375rem;
  }

  .locale-flag {
    border: 0;
    line-height: 0;
    padding: 0;
    opacity: .5;

    > img {
      width: 1.875rem;
    }

    &[aria-pressed="true"] {
      opacity: 1;
    }

    + .locale-flag {
      margin-left: .9375rem;
    }
  }

  @media (min-width: $breakpoint-large) {
    .locale-changer {
      margin-left: 2.1875rem;
      margin-top: 0;
    }
  }
</style>
